<template>
    <div class="box">
      <div class="flex" v-loading="loading">
        <el-divider content-position="center">设置打印配货单的二维码</el-divider>
        <div class="QRCode">
          <el-upload
            class="avatar-uploader"
            :action="pageUrl"
            :headers="heads"
            name="file"
            :file-list="fileList"
            :on-success="handleHeadSuccess"
            :before-upload="beforeAvatarUpload"
            :on-change="handleChange"
            :on-error="uploadError">
            <el-image
              style="width: 100px; height: 100px;background: #f0f0f0;font-size: 40px; text-align: center; line-height: 100px; color: #999;"
              :src="page.code"
              fit="fill">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </el-upload>
        </div>
      </div>
      <div class="flex">
        <el-divider content-position="center">打印配货单的页数</el-divider>
        <div class="print">
          <el-switch
            v-model="page.number"
            :active-value=1
            :inactive-value=0
            active-text="打印收款单"
            inactive-text="默认打印"
            @change="changeNumber">
          </el-switch>
        </div>
      </div>
    </div>
</template>

<script>
import { getToken } from 'util/auth'
import { updatePage, getPageInfo } from '../../../api/page'
import {Message} from 'element-ui'

export default {
  data: function () {
    return {
      page: {},
      appId: '',
      loading: true,
      squareUrl: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382d568c9dpng.png',
      heads: {},
      fileList: [],
      pageUrl: ''
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.appId = to.params.id
      vm.pageUrl = `/api/page/uploadQinniu/${to.params.id}`
    })
  },
  created () {
    this.heads = {'Authorization': 'bearer ' + getToken().accessToken}
    this.windowHeight = document.documentElement.offsetHeight - 310
    setTimeout(() => {
      this.getPage()
    }, 500)
  },
  methods: {
    changeNumber (index) {
      updatePage(this.appId, {number: index, pageId: this.page.pageId}).then(res => {
        console.log(res.data)
      })
    },
    uploadError () {
      this.$message.error('上传头像错误，请稍后重试')
    },
    handleChange (file, fileList) {
      this.fileList = fileList.slice(-1)
    },
    getPage () {
      let _this = this
      getPageInfo(_this.appId).then(res => {
        _this.page = res.data.data
        _this.loading = false
      })
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    handleHeadSuccess (response) {
      console.log(response)
      this.page.code = response.data
      Message({
        message: response.msg,
        type: 'success',
        duration: 1000
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .box
    padding 18px
    background #fff;
    border-radius 5px
    font-size 12px
    transition .3s
    box-shadow 0 0 8px 0 rgba(156, 156, 156, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5)
  .flex
    display flex
    flex-direction column
    text-align center
</style>
